import moment from 'moment';
import mutations from './mutations';
import actions from './actions';

export default {
  namespaced: true,
  modules: {
  },
  state: {
    allProjectsWithLoggedHoursByUsers: [],
    loggedHoursByProject: [],
    plannedHoursByProject: [],
    plannedHoursByUser: []
  },
  getters: {
    allProjectsWithLoggedHoursByUsers: (state) => {
      return state.allProjectsWithLoggedHoursByUsers;
    },
    loggedHoursByProject: (state) => {
      return state.loggedHoursByProject;
    },
    plannedHoursByProject: (state) => {
      return state.plannedHoursByProject;
    },
    plannedHoursByUser: (state) => {
      return state.plannedHoursByUser;
    }
  },
  mutations,
  actions
};
